<template>
  <div class="h-full flex flex-col" v-loading="saveLoading">
    <div>
      <el-page-header @back="$emit('cancel')" content="员工危害性应知卡"></el-page-header>
    </div>
    <div class="flex-1 overflow-y-auto mx-200px">
      <div class="pdf-panel px-10px pt-20px" ref="card">
        <div class="w-full text-3xl text-center h-60px leading-60px bg-color-primary">
          员工危害性应知卡
        </div>
        <div class="table-form border-1 border-color-default">
          <table class="table-body w-full">
            <tr class="border-b-1 bg-table-header">
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div class="text-color-primary">
                  岗位名称
                </div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.postName }}</div>
              </td>

              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>编号</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.postNum }}</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>风险等级</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.riskLevelStr }}</div>
              </td>
            </tr>
            <tr class="border-b-1">
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>工作关联风险区域</div>
              </td>
              <td colspan="5" class="w-1/6 border-r-1  p-10px table-cell">
                <div class="text-color-primary font-normal">
                  {{ formData.jobAssociatedRiskAreaStr }}
                </div>
              </td>
            </tr>
            <tr class="border-b-1 bg-table-header">
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>风险警示标识</div>
              </td>
              <td colspan="5" class="w-1/6 border-r-1  p-10px table-cell">
                <div class="text-color-primary font-normal">
                  {{ formData.warningSignStr }}
                </div>
              </td>
            </tr>
            <tr class="border-b-1">
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>警示区域图标</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell ">
                <div class="flex justify-center items-center" v-if="formData.fileList.length > 0">
                  <el-image
                    :fit="contain"
                    class="w-104px h-85px"
                    :src="formData.fileList[0].imgContent"
                    alt=""
                  />
                </div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div class="flex justify-center items-center" v-if="formData.fileList.length > 1">
                  <el-image
                    :fit="contain"
                    class="w-104px h-85px"
                    :src="formData.fileList[1].imgContent"
                    alt=""
                  />
                </div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div class="flex justify-center items-center" v-if="formData.fileList.length > 2">
                  <el-image
                    :fit="contain"
                    class="w-104px h-85px"
                    :src="formData.fileList[2].imgContent"
                    alt=""
                  />
                </div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div class="flex justify-center items-center" v-if="formData.fileList.length > 3">
                  <el-image
                    :fit="contain"
                    class="w-104px h-85px"
                    :src="formData.fileList[3].imgContent"
                    alt=""
                  />
                </div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div class="flex justify-center items-center" v-if="formData.fileList.length > 4">
                  <el-image
                    :fit="contain"
                    class="w-104px h-85px"
                    :src="formData.fileList[4].imgContent"
                    alt=""
                  />
                </div>
              </td>
            </tr>
            <tr class="border-b-1 bg-table-header">
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>危险有害因素</div>
              </td>
              <td colspan="2" class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.dangerousHarmfulFactors }}</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>风险管控措施</div>
              </td>
              <td colspan="2" class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.riskControlMeasures }}</div>
              </td>
            </tr>
            <tr class="border-b-1">
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>应急处置措施</div>
              </td>
              <td colspan="2" class=" w-1/6 border-r-1  p-10px table-cell">
                <div
                  v-for="(item, index) in emergencyMeasuresMap(formData.emergencyMeasures)"
                  :key="index"
                >
                  {{ index + 1 }}、{{ item }}
                </div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>应急电话</div>
              </td>
              <td colspan="2" class=" w-1/6 border-r-1  p-10px table-cell">
                <div
                  v-for="(item, index) in emergencyTelephoneMap(formData.emergencyTelephone)"
                  :key="index"
                >
                  {{ item }}
                </div>
              </td>
            </tr>
            <tr class="border-b-1 bg-table-header">
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div class="text-color-primary">
                  主管单位
                </div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.competentUnit }}</div>
              </td>

              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>主要负责人</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.principalChargePerson }}</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>现场负责人</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.fieldManager }}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="flex justify-center mt-20px">
      <el-button type="primary" size="small" @click="exportRiskCard" :disabled="saveLoading"
        >导出</el-button
      >
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import html2pdf from '@/components/safety/enumField/pdfPage'
import { EmployeesHazardCharacteristicsCardApi } from '@wiz-api/double-prevention-management'
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
const employeesHazardCharacteristicsCardApi = new EmployeesHazardCharacteristicsCardApi()

export default {
  name: 'staff-harm-card',
  props: {
    rowId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formData: {
        postName: '',
        postNum: '',
        jobAssociatedRiskAreaStr: '',
        riskLevel: null,
        warningSigns: null,
        warningSignPicture: '',
        dangerousHarmfulFactors: '',
        riskControlMeasures: '',
        emergencyMeasures: '',
        emergencyTelephone: '',
        competentUnit: '',
        principalChargePerson: '',
        fieldManager: '',
        annex: undefined,
        jobAssociatedRiskAreasIds: [],
        warningSignsIds: [],
        warningSignStr: '',
        riskLevelStr: '',
        fileList: [],
      },
      saveLoading: false,
      resultList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
      markList: [],
    }
  },
  mounted() {
    this.initForm()
  },
  computed: {
    emergencyMeasuresMap() {
      return (val) => {
        const splitStr = val.indexOf(';') > -1 ? ';' : '；'
        const valArr = val.split(splitStr)
        return _.filter(valArr, (ele) => {
          return ele
        })
      }
    },
    emergencyTelephoneMap() {
      return (val) => {
        const splitStr = val.indexOf(';') > -1 ? ';' : '；'
        const valArr = val.split(splitStr)
        return _.filter(valArr, (ele) => {
          return ele
        })
      }
    },
  },
  methods: {
    // 初始化表单
    async initForm() {
      this.saveLoading = true
      const [err, res] = await employeesHazardCharacteristicsCardApi.get(this.rowId)
      if (!err) {
        this.formData = {
          ...this.formData,
          ...res,
        }
        this.formData.riskLevelStr = _.filter(this.resultList, (item) => {
          return item.code === this.formData.riskLevel
        })[0]?.displayName
        this.getImgContent(this.formData.warningSignPicture.split(','))
      }
      this.saveLoading = false
    },
    // 获取图片内容
    /**
     * 获取图片内容并进行预览
     * @param {*} fileId 文件id
     */
    async getImgContent(fileId) {
      fileId.forEach(async (id) => {
        // 获取图片内容
        const [error, result] = await fileApi.getFileContent(id)
        if (!error) {
          const res = {
            id,
            imgContent: `data:image/jpg;base64,${result.content}`,
          }
          this.formData.fileList.push(res)
        }
      })
    },
    // 导出pdf
    exportRiskCard() {
      const pdfName = '员工危害性应知卡'
      html2pdf(this.$refs.card, pdfName)
    },
  },
}
</script>

<style scoped lang="scss">
.table-form {
  td:last-child {
    border-right: none;
  }
  .table-body {
    word-break: break-all;
    font-size: 14px;
    tr:last-child {
      border: none;
    }
    td:first-child {
      border-left: none;
    }
  }
}

::v-deep .el-card .el-card__header {
  padding: 10px;
}

::v-deep .custom-card {
  border-bottom: none !important;
}

::v-deep .el-card .el-card__header {
  padding: 0 !important;
}
</style>
